import { http, normalizePage } from '@shared/api';
import type { Page, UUID } from '@shared/api';
import type { BuyRequestDetail, BuyRequestFilters, BuyRequestListItem } from './types';

function toSearchParams(filters: BuyRequestFilters): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: filters.page ?? 0,
    size: filters.size ?? 20,
  };
  if (filters.status) params.status = filters.status;
  if (filters.hidden) params.hidden = filters.hidden;
  if (filters.q) params.q = filters.q;
  return params;
}

export const buyRequestApi = {
  list: async (filters: BuyRequestFilters): Promise<Page<BuyRequestListItem>> => {
    const raw = await http
      .get('buy-requests', { searchParams: toSearchParams(filters) })
      .json<unknown>();
    return normalizePage<BuyRequestListItem>(raw);
  },

  get: (id: UUID) => http.get(`buy-requests/${id}`).json<BuyRequestDetail>(),

  hide: (id: UUID, reason: string) =>
    http.post(`buy-requests/${id}/hide`, { json: { reason } }).json<void>(),

  unhide: (id: UUID) => http.post(`buy-requests/${id}/unhide`).json<void>(),
};
